import { useState, useEffect } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, MoneyInput, NumberInput, Select, TextInput, toDateOnly } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { useApi } from "../../hooks/useApi"
import { Currency } from "../../hooks/helpers"
import { useToday } from "../../hooks/useToday"
import { useParams } from "react-router-dom"
import { useCodesTvaOptions } from "./Articles"
import { getTotalsFactureDetail } from "./FacturesDetail"

function FacturesAchatDetailFields({ item, set, tab }) {
    const [facture, setFacture] = useState()
    const [temps, setTemps] = useState([])

    const t = useTranslations()
    const api = useApi()
    const today = useToday()
    const { id } = useParams()
    const codesTvaOptions = useCodesTvaOptions()
    const articleOptions = useOptions('articles', 'nom')
    const chantierQueryFilter = temps
        .filter(x => (
            (x.fournisseur4Id || x.fournisseur3Id || x.fournisseur2Id || x.fournisseur1Id) === facture.fournisseurId
        ))
        .map(x => `id=${x.chantierId}`)
        .join('&')
    const chantiersOptions = useOptions('chantiers', ['nom', 'descriptionFacture'], { query: chantierQueryFilter || undefined })

    useEffect(() => {
        if (!item.codeTva) set('codeTva')('VINGT_BIS')
        if (id === 'new' && item.factureAchatId) api.get(`/facturesAchatDetail?factureAchatId=${item.factureAchatId}`).then(factureDetails => {
            if (!item.ordre) set('ordre')(Math.max(...factureDetails.map(x => x.ordre), 0) + 1)
        })
    }, [id, item.factureAchatId])
    useEffect(() => {
        if (item.factureAchatId) api.get(`/facturesAchat/${item.factureAchatId}`).then(setFacture)
    }, [item.factureAchatId])
    useEffect(() => {
        if (facture) api.get(`/temps?${[
            `limit=100`,
            `dateDebut:lte=${encodeURIComponent(toDateOnly(today).toISOString())}`,
            `or:dateFin=`,
            `or:dateFin:gte=${encodeURIComponent(toDateOnly(today).toISOString())}`,
            `or2:fournisseur1Id=${encodeURIComponent(facture.fournisseurId)}`,
            `or2:fournisseur2Id=${encodeURIComponent(facture.fournisseurId)}`,
            `or2:fournisseur3Id=${encodeURIComponent(facture.fournisseurId)}`,
            `or2:fournisseur4Id=${encodeURIComponent(facture.fournisseurId)}`,
        ].join('&')}`).then(setTemps)
        else setTemps([])
    }, [facture])

    const changeChantier = (id, chantier) => {
        set('chantierId')(id)
        if (id) {
            if (item.articleId) set('articleId')(null)
            set('quantite')(1)
            set('prixUnitaire')(chantier.prixAchat)
            set('codeTva')(chantier.codeTva)
            set('nom')(chantier.descriptionFacture)
        } else if (!item.articleId) {
            set('articleId')(null)
            set('quantite')(null)
            set('prixUnitaire')(null)
            set('codeTva')(null)
            set('nom')(null)
        }
    }
    const changeArticle = (id, article) => {
        set('articleId')(id)
        if (id) {
            if (item.chantierId) set('chantierId')(null)
            set('quantite')(1)
            set('prixUnitaire')(article.prixAchat)
            set('codeTva')(article.codeTva)
            set('nom')(article.nom)
        } else if (!item.chantierId) {
            set('chantierId')(null)
            set('quantite')(null)
            set('prixUnitaire')(null)
            set('codeTva')(null)
            set('nom')(null)
        }
    }

    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
            <AsyncSelect className="grow" label={t("Chercher chantier")} value={item.chantierId} onChange={changeChantier} options={chantiersOptions} />
            <AsyncSelect className="grow" label={t("Chercher article")} value={item.articleId} onChange={changeArticle} options={articleOptions} />
        </Row>
        <TextInput label={t("Désignation")} value={item.nom} onChange={set('nom')} required />
        <Row>
            <MoneyInput label={t("Prix unitaire")} value={item.prixUnitaire} onChange={set('prixUnitaire')} required min={item.exportPopsy ? "0.01" : "0"} />
            <NumberInput label={t("Quantité")} value={item.quantite} onChange={set('quantite')} required min={item.exportPopsy ? "1" : "0"} step="0.001" />
            <Select label={t("Code TVA")} value={item.codeTva} onChange={set('codeTva')} options={codesTvaOptions} required />
        </Row>
        <Checkbox label={t("Export Popsy")} value={item.exportPopsy} onChange={set('exportPopsy')} />
        <Row>
            <MoneyInput className="grow" label={t("Total HTVA")} value={getTotalsFactureDetail(item, codesTvaOptions).totalHtva} disabled />
            <MoneyInput className="grow" label={t("Total TVA")} value={getTotalsFactureDetail(item, codesTvaOptions).totalTva} disabled />
            <MoneyInput className="grow" label={t("Total TTC")} value={getTotalsFactureDetail(item, codesTvaOptions).totalTtc} disabled />
        </Row>
    </>
}

export function FacturesAchatDetailsList(props) {
    const codesTvaOptions = useCodesTvaOptions()
    const t = useTranslations()

    return <ListPage model="facturesAchatDetail" title={t("Détails")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Désignation')]: 'nom',
        [t('Code TVA')]: { sort: 'codeTva', value: item => <FkLink>{codesTvaOptions.find(x => x.value === item.codeTva).label}</FkLink> },
        [t('Prix unitaire')]: { sort: 'prixUnitaire', value: item => <Currency value={item.prixUnitaire} /> },
        [t('Quantité')]: 'quantite',
        [t('Total HTVA')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalHtva} /> },
        [t('Total TTC')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalTtc} /> },
    }} {...props} />
}

export function FacturesAchatDetailDetail(props) {
    const t = useTranslations()
    return <DetailPage model="facturesAchatDetail" title={t("Factures Detail")} Fields={FacturesAchatDetailFields} defaults={{
        exportPopsy: true,
        quantite: 1,
    }} {...props} />
}
